export default __webpack_public_path__ + "static/media/109.f8215a88.jpg";